import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
    name: "notifications",
    initialState: {
      pageTrigger: false, 
      dialogTrigger: false, 
    },
    reducers: {
      togglePageTrigger: (state) => {
        state.pageTrigger = !state.pageTrigger; 
      },
      toggleDialogTrigger: (state) => {
        state.dialogTrigger = !state.dialogTrigger; 
      },
    },
  });

export const { togglePageTrigger,toggleDialogTrigger } = notificationSlice.actions;
export default notificationSlice.reducer;
